module.exports = __webpack_public_path__ + "static/media/algae5.5cc496b0.svg";